import styled from '@emotion/styled'
import { FunctionComponent } from 'react'
import Button from '~/components/Button'
import { useGlobalModal } from '~/components/layout/GlobalModal'
import { Modal } from '~/components/Modal'

const BoldText = styled.span`
  font-weight: bold;
`

type UnarchiveStackModalProps = { stackName: string; onUnarchive: () => Promise<void> }
export const UnarchiveStackModal: FunctionComponent<UnarchiveStackModalProps> = ({ stackName, onUnarchive }) => {
  const { close } = useGlobalModal()
  return (
    <Modal.Content>
      <Modal.Title>Unarchive {stackName}</Modal.Title>

      <Modal.Body>
        <div>
          You are about to unarchive <BoldText>{stackName}</BoldText>.
        </div>
        <div>Please verify the stack integrity before deploying it. Some elements (ad units, rules, integrations) may be updated since last time.</div>
      </Modal.Body>

      <Modal.Actions>
        <Button variant={'tertiary'} onClick={close} trackingLabel={'adm-sites-stacks-unarchiving-cancel'}>
          Cancel
        </Button>
        <Button variant={'primary'} onClick={onUnarchive} trackingLabel={'adm-sites-stacks-unarchiving-confirm'}>
          Unarchive
        </Button>
      </Modal.Actions>
    </Modal.Content>
  )
}
